import React from "react";
import AuthorisedClinicComponent from "./authorisedClinic.component";
import { useSelector } from "react-redux";

export default function AuthorisedClinicContainer({ id, isTemplateEditor }) {
  const { isVisible } = useSelector((state) =>
    isTemplateEditor
      ? state.products.template.workspaceSetting.setting.components[id]
      : state.productPage.components[id]
  );
  const lang = useSelector((state) => state.constant.languages);
  const language = useSelector((state) => state.profile.language);
  const uiSetting = useSelector((state) => state.setting.uiSetting);

  return (
    isVisible && (
      <AuthorisedClinicComponent
        lang={lang}
        language={language}
        uiSetting={uiSetting}
      />
    )
  );
}
